import React from "react";
import { useSearchParams } from "react-router-dom";
import MemberViewModal from "./MemberViewModal";

const MemberViewFullPage = () => {
  const [searchParams] = useSearchParams();
  const memberId =
    searchParams.get("member_id") || searchParams.get("memberId") || "";
  const initialTab = searchParams.get("tab") || "member-details";

  if (!memberId) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
          <h2 className="text-lg font-semibold text-slate-800 mb-2">
            Missing Parameters
          </h2>
          <p className="text-sm text-slate-500">
            This page requires a <strong>member_id</strong> query parameter.
          </p>
        </div>
      </div>
    );
  }

  return (
    <MemberViewModal
      memberId={memberId}
      onClose={() => window.close()}
      variant="fullpage"
      initialTab={initialTab}
    />
  );
};

export default MemberViewFullPage;
